/**
 * en-GB messages added by Phase 3 task W23 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w23EnGB = {
    'nav.evacuation': 'Evacuation',
    'nav.evacuation.desc': 'Start an evacuation and run the roll call',
    'nav.reports.evacuations': 'Evacuations',
    'nav.firePanels': 'Fire panels',
    'nav.compliance': 'Compliance documents',
    'nav.inductions': 'Inductions',
    'nav.nfcCards': 'NFC cards',
    'nav.permits': 'Permits to work',
    'nav.loneWorking': 'Lone working',
    'nav.displays': 'Reception displays',
    'membersUi.drawer.tab.documents': 'Documents',
    'membersUi.drawer.tab.cards': 'Cards',
    'membersUi.drawer.tab.musterPoint': 'Muster point',
    'membersUi.drawer.tab.loneWorking': 'Lone working',
    'w23.permit.raise': 'Raise a permit to work',
    'w23.kioskEvents.tab': 'Kiosk events',
    'w23.kioskEvents.title': 'Kiosk events to review',
    'w23.kioskEvents.intro': 'Sign-ins and sign-outs from kiosks that were refused, are still waiting, or went through with a warning. Mark each one as reviewed when you have looked at it.',
    'w23.kioskEvents.col.received': 'Received',
    'w23.kioskEvents.col.device': 'Kiosk',
    'w23.kioskEvents.col.type': 'Event',
    'w23.kioskEvents.col.status': 'Status',
    'w23.kioskEvents.col.reviewed': 'Review',
    'w23.kioskEvents.col.actions': 'Actions',
    'w23.kioskEvents.type.sign_in': 'Sign-in',
    'w23.kioskEvents.type.sign_out': 'Sign-out',
    'w23.kioskEvents.type.member_create': 'New member',
    'w23.kioskEvents.status.all': 'All',
    'w23.kioskEvents.status.rejected': 'Refused',
    'w23.kioskEvents.status.pending': 'Waiting',
    'w23.kioskEvents.status.validation_warning': 'Warning',
    'w23.kioskEvents.from': 'From',
    'w23.kioskEvents.to': 'To',
    'w23.kioskEvents.unreviewedOnly': 'Hide events already reviewed',
    'w23.kioskEvents.unreviewed': 'Not reviewed',
    'w23.kioskEvents.reviewedBy': 'Reviewed by {who} on {when}',
    'w23.kioskEvents.openVisit': 'Open visit',
    'w23.kioskEvents.markReviewed': 'Mark as reviewed',
    'w23.kioskEvents.empty': 'Nothing to review.',
};
//# sourceMappingURL=w23.js.map